import * as yup from "yup";

export const addNewSectionSchema = yup.object().shape({
  checklistSectionName: yup.string().required("checklistBuilder_section_name_required"),
  sectionItems: yup.array().min(1, "checklistBuilder_section_item_required").required(),
});
